import { useCallback, useState } from 'react'
import { useMediaQuery, useTheme } from '@material-ui/core'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import PageMetaData from '@v4/utils/data/PageMetaData'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { useMainContainerMinMargins } from '@v4/components/common/SectionItem'
import useStyles from './Video5.styled'

export const useVideo5 = props => {
	const { metaData } = props
	const [open, setOpen] = useState(false)

	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
	const minMargins = useMainContainerMinMargins()

	const isCenter = isMobile && metaData.mobileImagePosition?.isCenterImage

	const classes = useStyles({ ...props, isMobile, minMargins, isCenter })

	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleTitleClick } = useFieldFocus({ metaData: metaData.title })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.image })
	const { handleFocus: handleMobileImageClick } = useFieldFocus({ metaData: metaData.mobileImage })
	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })
	const { handleFocus: handleAdditionalButtonClick } = useFieldFocus({ metaData: metaData.additionalButtonAction })

	const { editable: titleEditable, handleChange: handleTitleChange } = useEditorMeta({
		metaData: metaData.title,
		key: 'title',
	})

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	const { editable: additionalButtonTextEditable, handleChange: handleAdditionalButtonTextChange } = useEditorMeta({
		metaData: metaData.additionalButtonText,
		key: 'additionalButtonText',
	})

	const isMobileImage = isMobile && !!metaData.mobileImage?.image

	const image = isMobileImage ? metaData.mobileImage : metaData.image

	const isImageExist = !!image?.image

	const handleToggleModal = useCallback(() => setOpen(prev => !prev), [])

	return [
		{
			classes,
			open,
			withImage: isImageExist && !isCenter,
			withMobileImageCentered: isImageExist && isCenter,
			image,
			desktopDirection: isMobile ? null : metaData.videoPosition?.contentDirection(PageMetaData.ALIGNMENT.LEFT),
			mobileDirection: isMobile
				? metaData.mobileImagePosition?.contentDirection(PageMetaData.ALIGNMENT.LEFT)
				: null,
			withModal: !!metaData.video?.metaValue,
			video: metaData.video?.metaValue,
			isMobile,
			key: isMobile ? 'mobile' : 'desktop',
			additionalButtonColor: metaData.additionalButtonColor?.metaValue,

			title: metaData.title?.metaValue,
			titleConfig: metaData.title?.config,
			titleKey: metaData.title?.tierKey,
			titleEditable,

			text: metaData.text?.metaValue,
			textConfig: metaData.text?.config,
			textKey: metaData.text?.tierKey,
			textEditable,

			buttonText: metaData.buttonText?.metaValue,
			buttonTextConfig: metaData.buttonText?.config,
			buttonAction: metaData.buttonAction?.metaValue,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonTextKey: metaData.buttonText?.tierKey,
			buttonTextEditable,

			additionalButtonText: metaData.additionalButtonText?.metaValue,
			additionalButtonTextKey: metaData.additionalButtonText?.tierKey,
			additionalButtonTextConfig: metaData.additionalButtonText?.config,
			additionalButtonAction: metaData.additionalButtonAction?.metaValue,
			additionalButtonLink: metaData.additionalButtonLink?.metaValue,
			additionalButtonTextEditable,
		},
		{
			handleToggleModal,
			handleImageClick: isMobileImage ? handleMobileImageClick : handleImageClick,

			handleTitleClick,
			handleTitleChange,

			handleTextClick,
			handleButtonTextChange,

			handleButtonClick,
			handleTextChange,

			handleAdditionalButtonTextChange,
			handleAdditionalButtonClick,
		},
	]
}
